/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { createEntity, getEntity, reset, updateEntity } from './global-property.reducer';

export const GlobalPropertyUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const globalPropertyEntity = useAppSelector(state => state.globalProperty.entity);
  const loading = useAppSelector(state => state.globalProperty.loading);
  const updating = useAppSelector(state => state.globalProperty.updating);
  const updateSuccess = useAppSelector(state => state.globalProperty.updateSuccess);

  const handleClose = () => {
    navigate(`/global-property${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.timestampentry !== undefined && typeof values.timestampentry !== 'number') {
      values.timestampentry = Number(values.timestampentry);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.lastupdated !== undefined && typeof values.lastupdated !== 'number') {
      values.lastupdated = Number(values.lastupdated);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }

    const entity = {
      ...globalPropertyEntity,
      ...values,
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...globalPropertyEntity,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.globalProperty.home.createOrEditLabel" data-cy="GlobalPropertyCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.globalProperty.home.createOrEditLabel">Create or edit a GlobalProperty</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="global-property-id"
                  label={translate('tinyMedicRestApp.globalProperty.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.globalProperty.property')}
                id="global-property-property"
                name="property"
                data-cy="property"
                type="text"
                validate={{
                  maxLength: { value: 255, message: translate('entity.validation.maxlength', { max: 255 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.globalProperty.propertyValue')}
                id="global-property-propertyValue"
                name="propertyValue"
                data-cy="propertyValue"
                type="text"
                validate={{
                  maxLength: { value: 255, message: translate('entity.validation.maxlength', { max: 255 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.globalProperty.description')}
                id="global-property-description"
                name="description"
                data-cy="description"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.globalProperty.datatypeClassname')}
                id="global-property-datatypeClassname"
                name="datatypeClassname"
                data-cy="datatypeClassname"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.globalProperty.datatypeConfig')}
                id="global-property-datatypeConfig"
                name="datatypeConfig"
                data-cy="datatypeConfig"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.globalProperty.preferredHandlerClassname')}
                id="global-property-preferredHandlerClassname"
                name="preferredHandlerClassname"
                data-cy="preferredHandlerClassname"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.globalProperty.handlerConfig')}
                id="global-property-handlerConfig"
                name="handlerConfig"
                data-cy="handlerConfig"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.globalProperty.dirty')}
                id="global-property-dirty"
                name="dirty"
                data-cy="dirty"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.globalProperty.active')}
                id="global-property-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.globalProperty.timestampentry')}
                id="global-property-timestampentry"
                name="timestampentry"
                data-cy="timestampentry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.globalProperty.microSec')}
                id="global-property-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.globalProperty.lastupdated')}
                id="global-property-lastupdated"
                name="lastupdated"
                data-cy="lastupdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.globalProperty.cursor')}
                id="global-property-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/global-property" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default GlobalPropertyUpdate;
